import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IQuickUrl } from 'src/app/state/quick-url.model';

@Injectable({
  providedIn: 'root',
})
export class QuickUrlDataService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getQuickUrls() {
    return this.httpClient.get<IQuickUrl[]>('api/quick-links');
  }

  public postQuickUrls(data: IQuickUrl) {
    return this.httpClient.post<IQuickUrl>('api/quick-links', data);
  }

  public deleteQuickUrl(shortName: string) {
    return this.httpClient.delete(`api/quick-links/${shortName}`);
  }
}
